export const styles = (theme) => ({
	tabs: {
		marginTop: "40px",
		borderBottom: "1px solid #e0e0e0",
		minHeight: "47px",
		"& .MuiTabs-flexContainer": {
			justifyContent: "center",
			gap: "10px",
		},
	},
	tab: {
		width: "303px",
		height: "47px",
		minWidth: "303px",
		minHeight: "47px",
		padding: "12px 20px",
		textTransform: "none",
		fontFamily: "Montserrat, sans-serif",
		fontWeight: 700,
		fontSize: "24px",
		lineHeight: "100%",
		letterSpacing: 0,
		textAlign: "center",
		color: "#98A5B0",
		backgroundColor: "transparent",
		"&:hover": {
			color: "#7a8690",
			backgroundColor: "transparent",
		},
	},
	activeTab: {
		width: "320px",
		height: "47px",
		minWidth: "320px",
		minHeight: "47px",
		padding: "12px 20px",
		textTransform: "none",
		fontFamily: "Montserrat, sans-serif",
		fontWeight: 700,
		fontSize: "24px",
		lineHeight: "100%",
		letterSpacing: 0,
		textAlign: "center",
		color: "#0066CC",
		backgroundColor: "transparent",
		"&:hover": {
			color: "#0066CC",
			backgroundColor: "transparent",
		},
	},
	indicator: {
		backgroundColor: "#0066CC",
		height: "3px",
	},
	utilizarCupomContainer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: "40px 20px",
		minHeight: "400px",
		"& .x-web-ordering-pedido__dados--card": {
			marginBottom: "30px",
			width: "100%",
			display: "flex",
			justifyContent: "center",
		},
	},
	aplicarButton: {
		width: "190px",
		height: "48px",
		borderRadius: "100px",
		backgroundColor: "#0094DB",
		color: "#ffffff",
		border: "none",
		fontSize: "17px",
		fontWeight: 600,
		fontFamily: "Montserrat, sans-serif",
		cursor: "pointer",
		opacity: 1,
		transition: "all 0.3s ease",
		"&:hover": {
			backgroundColor: "#0084c5",
			transform: "scale(1.02)",
		},
		"&:disabled": {
			backgroundColor: "#cccccc",
			opacity: "0.6",
			cursor: "not-allowed",
		},
	},
});